/**
 * Cross-package API contract types (SRS §6).
 *
 * Both frontends and the API import from here so a change to the wire format is a
 * compile error in every consumer at once — the reason the SRS §3.1 chose a monorepo.
 */
// ─── Enums (mirror the Prisma enums exactly) ──────────────────────────────────
export const Role = { CUSTOMER: 'CUSTOMER', ADMIN: 'ADMIN', SUPER_ADMIN: 'SUPER_ADMIN' };
export const UserStatus = { ACTIVE: 'ACTIVE', SUSPENDED: 'SUSPENDED' };
export const ProductStatus = { ACTIVE: 'ACTIVE', DRAFT: 'DRAFT', ARCHIVED: 'ARCHIVED' };
/** SRS §5.5 workflow: PENDING > CONFIRMED > SHIPPED > DELIVERED, CANCELLED before SHIPPED. */
export const OrderStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    SHIPPED: 'SHIPPED',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
};
/** Legal transitions. Enforced server-side; the admin UI greys out anything absent here. */
export const ORDER_STATUS_TRANSITIONS = {
    PENDING: ['CONFIRMED', 'CANCELLED'],
    CONFIRMED: ['SHIPPED', 'CANCELLED'],
    SHIPPED: ['DELIVERED'],
    DELIVERED: [],
    CANCELLED: [],
};
export const PaymentMethod = { CASH_ON_DELIVERY: 'CASH_ON_DELIVERY', MPESA: 'MPESA' };
export const PaymentStatus = {
    UNPAID: 'UNPAID',
    PENDING: 'PENDING',
    PAID: 'PAID',
    FAILED: 'FAILED',
    REFUNDED: 'REFUNDED',
};
/** SRS §5.3 — Sharp output matrix. */
export const IMAGE_VARIANTS = {
    thumbnail: { size: 300, quality: 80 },
    medium: { size: 600, quality: 80 },
    large: { size: 1200, quality: 85 },
};
// ─── Domain constants ─────────────────────────────────────────────────────────
export const LIMITS = {
    /** SRS §4.7. */
    wishlistMaxItems: 100,
    /** SRS §5.3, §10.4. */
    uploadMaxBytes: 10 * 1024 * 1024,
    /** SRS §7.3 — SEO column widths. */
    metaTitleMax: 70,
    metaDescriptionMax: 160,
    passwordMin: 8,
};
/** SRS §2.4 / §8.4 — Kenyan mobile: +254XXXXXXXXX, 07XXXXXXXX or 01XXXXXXXX. */
export const KE_PHONE_REGEX = /^(?:\+254|0)(?:1|7)\d{8}$/;
/** SRS §7.1.3 / Appendix B.1 — YouTube IDs are exactly 11 URL-safe chars. */
export const YOUTUBE_ID_REGEX = /^[a-zA-Z0-9_-]{11}$/;
/** SRS §4.1 — min 8 chars, one upper, one lower, one digit. */
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
//# sourceMappingURL=types.js.map